import { render, staticRenderFns } from "./DepartamentoSelect.vue?vue&type=template&id=bfc3ab0c&"
import script from "./DepartamentoSelect.vue?vue&type=script&lang=js&"
export * from "./DepartamentoSelect.vue?vue&type=script&lang=js&"
import style0 from "./DepartamentoSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports